// extracted by mini-css-extract-plugin
module.exports = {"root":"_171iT","up":"_2Dt8G","down":"_22a7h","disabled":"q1Rrr"};